import styled from "styled-components";
import {Table} from "antd";

export const StyledRupTable = styled(Table)`

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  .ant-table-header {
    .ant-table-cell {
      font-size: 12px;
    }

    .vertical {
      writing-mode: vertical-rl;
      rotate: 180deg;
      border: 0 !important;

      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: transparent;
        border: 1px solid #f0f0f0;
      }
    }
  }

  .ant-table-body {
    
    .ant-table-cell-fix-left{
      //background: transparent !important;
    }

    .ant-table-summary {
      background-color: #968cff;
      color: #fff;
      text-align: center;
      font-weight: 700;
    }

    .ant-table-cell {
      font-size: 14px;
    }

    .text-danger {
      color: #FF3B30 !important;
    }

    .control_work,
    .course_projects,
    .course_work,
    .credit,
    .exam,
    .index,
    .individual,
    .industrial_training,
    .key,
    .lab_pract_work,
    .name,
    .discipline_id,
    .offset,
    .parent_id,
    .professional_training,
    .row_type,
    .sem_1,
    .sem_2,
    .sem_3,
    .sem_4,
    .sem_5,
    .sem_6,
    .sem_7,
    .sem_8,
    .sort,
    .theoretical_training,
    .total_hours{
      
    }

    .qualification,
    .qualification_total,
    .group,
    .module,
    .module_evelated,
    .qualification_evelated,
    .ro,
    .discipline,
    .discipline_from_module,
    .discipline_evelated,
    .qualification_evelated_total,
    .row_from_tup {
      td:first-child {
        position: relative;

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 3px;
        }
      }
    }

    .qualification {
      td:first-child {
        &:before {
          background-color: #5856D6;
        }
      }
    }

    .qualification_total {
      background-color: #773DBD;

      td:first-child {
        &:before {
          background-color: #968cff;
        }
      }
    }

    .group {
      background-color: rgba(0, 156, 213, 0.2);
      color: rgba(0, 156, 213, 0.9) !important;
      
      td:first-child {
        &:before {
          background-color: #009CD5;
        }
      }
    }

    .module {
      color: rgba(255, 149, 0, 0.9) !important;

      td:first-child {
        &:before {
          background-color: #FF9500;
        }
      }
    }

    .module_evelated {
      color: #66d4cf;
      td:first-child {
        &:before {
          background-color: #66d4cf;
        }
      }
    }

    .qualification_evelated {
      td:first-child {
        &:before {
          background-color: #ac8e68;
        }
      }
    }

    .ro {
      td:first-child {
        &:before {
          background-color: #AF52DE;
        }
      }
    }

    .discipline {
      td:first-child {
        &:before {
          background-color: #ff00ff;
        }
      }
    }

    .discipline_from_module {
      td:first-child {
        &:before {
          background-color: #8E8E93;
        }
      }
    }

    .discipline_evelated {
      td:first-child {
        &:before {
          background-color: #520000;
        }
      }
    }

    .qualification_evelated_total {
      background-color: rgba(81, 37, 143, 0.3);

      td:first-child {
        &:before {
          background-color: transparent;
        }
      }
    }

    .row_from_tup {
      background-color: rgba(255, 251, 230, 1);

      td:first-child {
        &:before {
          background-color: rgba(255, 251, 230, 1);
        }
      }
    }
  }
`